import { combineReducers } from "redux";
import practiceReducer from "./practiceReducer";
import userReducer from "./userReducer";

export default combineReducers({
  practice: practiceReducer,
  user:userReducer
});
